// Module
var code = "<div class=\"invite-to-signup\" ng-if=\"!user\"> <p>Register or sign in to see the widest selection of listings available from all brokers. Save listings, keep notes and keep track of your property search.</p> <a trk=\"search-signup-invite\" ng-click=\"modalLogin()\" class=\"btn btn-inverse\">Register/ Sign In</a> </div>";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src974318165/src/frontend/js/directives/public/inviteToSignup.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;